import { createActions } from 'reduxsauce'

export const { Types: AnalyticsTypes, Creators: AnalyticsActions } = createActions({
    postAnalytics: ['click', 'to']
})
// I don't need to put some postAnalytics data to store, so I don't need reducer
